class UserNotAuthorizedError extends Error {
  constructor (message) {
    super(message)
    this.name = 'UserNotAuthorizedError'
    this.code = 'userNotAuthorized'
  }
}

export default UserNotAuthorizedError
